<template>
  <div
    :class="[
      accountTypes.selectedAccount.account_type == 'DEMO'
        ? 'theme-demo'
        : accountTypes.selectedAccount.account_type == 'CONTEST'
          ? 'theme-camp'
          : '',
      'text-ontick-carbon-900 dark:text-gray-300',
    ]"
  >
    <template v-if="is_loading || config_error">
      <transition
        enter-active-class="ease-in-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in-out duration-300"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ontick-loading-screen-component v-if="is_loading" />
        <ontick-error-screen-component v-else />
      </transition>
    </template>
    <vue-page-transition v-else name="fade-in-right" class="overflow-hidden bg-transparent">
      <router-view></router-view>
    </vue-page-transition>
    <!-- <div
      class="fixed bottom-12 right-12 hidden lg:flex"
      v-if="getWebsocketIsConnected === false"
    >
      <span
        class="
          absolute
          right-0
          top-0
          w-4
          h-4
          bg-ontick-blue-600
          animate-ping
          rounded-full
        "
      ></span>
      <button
        class="rounded-full px-8 py-4 bg-ontick-blue-900 font-bold shadow-lg"
        @click="setupWebsocket(isSharedWorker)"
      >
        Conectar
      </button>
    </div> -->
    <portal-target name="modal" multiple />
    <!-- comment -->
  </div>
</template>

<script>
// import Loading from "./shared/components/loading/loading.component";
import EventAndNotification from "./modules/event-and-notification/event-and-notification.mixin";
import { Auth } from "aws-amplify";
import EventBus from "./shared/utils/event_bus";

import { mapState, mapActions, mapGetters } from "vuex";
import OntickLoadingScreenComponent from "./shared/components/basic/ontick-loading-screen.component.vue";
import OntickErrorScreenComponent from "./shared/components/basic/ontick-error-screen.component.vue";

export default {
  name: "App",

  mixins: [EventAndNotification],

  components: {
    // Loading,
    OntickLoadingScreenComponent,
    OntickErrorScreenComponent,
  },

  data() {
    return {
      prompt: false,
      route_name: "",
      user: {},
      user_code: null,
      isLoggedIn: false,
      is_loading: false,
      config_error: false,
    };
  },

  computed: {
    ...mapState({
      authenticated: (state) => state.accountTypes.authenticated,
      selectedAccount: (state) => state.accountTypes.selectedAccount,
    }),
    ...mapGetters({
      getWebsocketIsConnected: "config/getWebsocketIsConnected",
      accountTypes: "accountTypes/getAccountTypes",
      getId: "config/getId",
      getUserPlan: "config/getUserPlan",
      getUiTheme: "config/getUiTheme",
    }),
  },

  methods: {
    ...mapActions({
      setUserConfig: "config/setUserConfig",
      updateAccount: "accountTypes/updateAccount",
      fetchAccounts: "accountTypes/fetchAccounts",
      saveEvent: "eventAndNotification/saveEvent",
      setMessages: "config/setMessages",
      setWebsocketIsConnected: "config/setWebsocketIsConnected",
      setMarketdata: "marketdata/setMarketdata",
      clearMarketdata: "marketdata/clearMarketdata",
      setId: "config/setId",
      changeTheme: "config/changeTheme",
      setUiTheme: "config/setUiTheme",
    }),

    isLocalhost() {
      return Boolean(
        window.location.hostname === "localhost" ||
          // [::1] is the IPv6 localhost address.
          window.location.hostname === "[::1]" ||
          // 127.0.0.1/8 is considered localhost for IPv4.
          window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
      );
    },

    detectedMobile() {
      let check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          ) ||
          /constructor/i.test(window.HTMLElement) ||
          (function (p) {
            return p.toString() === "[object SafariRemoteNotification]";
          })(!window["safari"] || (typeof safari !== "undefined" && safari.pushNotification))
        )
          check = true;
      })(navigator.userAgent || navigator.vendor);

      return check;
    },

    async setupWebsocket() {
      const accessToken = (await Auth.currentSession()).getAccessToken().getJwtToken();
      const userCode = await this.user_code;
      const isLocalhost = this.isLocalhost();

      // if (process.env.NODE_ENV === "development") {
      //   if (this.isSharedWorker) {
      //     console.log("[SHARED WORKER]");
      //   } else {
      //     console.log("[WORKER]");
      //   }
      // }

      this.worker.sendMessage({
        type: "START_WS",
        data: {
          accessToken: accessToken,
          userCode: await userCode,
          isLocalhost: isLocalhost,
          isSharedWorker: this.isSharedWorker,
          devMode: true,
        },
      });
    },

    ui_Dark(newTheme) {
      if (newTheme === "LIGHT") {
        document.querySelector("html").classList.remove("dark");
      } else {
        document.querySelector("html").classList.add("dark");
      }
    },

    async checkLogin() {
      try {
        await Auth.currentAuthenticatedUser();
        return true;
      } catch (err) {
        this.isLoggedIn = false;
        return false;
      }
    },

    async getConfig() {
      this.is_loading = true;
      try {
        if (!(await this.checkLogin())) return;
        const response = await this.setUserConfig();
        this.user_code = response.user_code;
        this.fetchAccounts(response.accounts);
        this.setupWebsocket();
      } catch (err) {
        if (err.data.status == "error") {
          this.setUserConfig(err.data);
        }
        this.config_error = true;
      } finally {
        if (await this.checkLogin()) {
          this.setMessages();
        }
        this.is_loading = false;
      }
    },
  },

  watch: {
    accountTypes: {
      deep: true,
      handler(val) {
        this.user = val;
        // return val;
      },
    },
    "$route.name": {
      deep: true,
      handler(val) {
        this.route_name = val;
        if (this.user.selectedAccount) {
          document.title = `${val} | OnTick (${this.user.selectedAccount.broker_name} - ${this.user.selectedAccount.account_number})`;
        }
      },
    },
    config: {
      deep: true,
      handler(newTheme) {
        newTheme === "LIGHT"
          ? document.querySelector("html").classList.remove("dark")
          : document.querySelector("html").classList.add("dark");
      },
    },
    getUiTheme: {
      immediate: true,
      handler() {
        let theme = localStorage.getItem("ui_theme");
        this.ui_Dark(theme);
        this.setUiTheme(theme);
      },
    },
  },

  created() {
    EventBus.$on("EVENT", (e) => {
      this.saveEvent(e).catch((err) => {
        console.error(err);
      });
    });

    EventBus.$on("IS_CONNECTED", (e) => {
      this.setWebsocketIsConnected(e.data);
    });

    EventBus.$on("MARKET_DATA", (e) => {
      // console.log(e);
      if (this.$route.name !== "Admin") {
        const { timeframe, msg_type, bid_price, bid_volume, ask_price, ask_volume, last_price } = e.data;
        let obj = {
          symbol: e.symbol,
          timeframe,
          msg_type,
          bid_price,
          bid_volume,
          ask_price,
          ask_volume,
          last_price,
        };

        // if (obj.symbol !== "WDOFUT") console.log(obj.symbol, obj.last_price);
        this.setMarketdata(obj);
      }
    });

    EventBus.$on("CLEAR_MARKET_DATA", (e) => {
      // console.log("clear md");
      this.clearMarketdata();
    });

    EventBus.$on("LOGIN_SUCCESSFUL", async () => {
      try {
        await this.getConfig();
        // console.log(this.getUserPlan);
      } catch (err) {
        console.error(err);
      }
    });

    EventBus.$on("REGISTER_PORT_ID", ({ data }) => {
      this.setId(data);
    });

    window.addEventListener("beforeunload", () => {
      this.worker.sendMessage({
        type: "REMOVE_SHARED_WORKER_CONSUMER",
        data: this.getId,
      });
    });
  },

  async mounted() {
    // window.addEventListener("storage", (e) => {
    //   console.log(e);
    // });
    this.worker.sendMessage({ type: "CHECK_CONNECTION" });
    await this.getConfig();
    if (!localStorage.getItem("ui_theme")) {
      this.changeTheme("dark");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/app/assets/scss/style";
</style>
